<template>
  <div class="dataDirectory">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">图纸目录配置</span>
        <div class="head-text"></div>
      </div>
      <el-container>
        <!-- 这里是侧边栏-->
        <div class="mar-top20">
          <el-aside width="200px" class="elAside">
            <el-button type="primary" size="small" @click="showAll"
              >显示全部目录</el-button
            >
            <div class="zTreeDiv">
              <ul id="ProjectFileTree" class="ztree"></ul>
            </div>
            <div id="ProjectFileRemenu">
              <ul>
                <li id="addProjectFile">添加</li>
                <li id="updateProjectFile">修改</li>
                <li id="delProjectFile">删除</li>
              </ul>
            </div>
          </el-aside>
        </div>
        <el-main>
          <div class="rygl-table">
            <el-table
              :data="inform"
              v-loading="tableLoading"
              class="width100-mar-bot20"
              height="72vh"
            >
              <el-table-column
                align="center"
                prop="label"
                label="名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="Count"
                label="文件数量"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="user"
                label="维护人员"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="DateTime"
                label="更新时间"
              ></el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-container>
    </el-card>
  </div>
</template>

<script>
import {
  Getpdrwaingtree,
  AddDrwaingTree,
  EditDrwaingTree,
  DelDrwaingTree,
  ChangeDrwaingTree,
  FindDrawingInfo,
} from "@/setAxios.js";
export default {
  name: "ProjectInformation",
  data() {
    return {
      inform: [],
      tableLoading: false,
      ids: "null",
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
    };
  },
  methods: {
    showAll() {
      this.zNodes.forEach((d) => {
        var node = this.zTeeObj.getNodeByParam("pjdt01", d.pjdt01);
        if (node != null) {
          this.zTeeObj.checkNode(node, true, true);
        }
      });

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        this.ids += _split + element.pjdt01;
        _split = ",";
      });
      this.getData();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pjdt02",
          },
          simpleData: {
            enable: true,
            idKey: "pjdt01",
            pIdKey: "pjdt03",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          beforeDrop: beforeDrop,
          onCheck: onCheck,
          onClick: onclick,
        },
      };
      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.zNodes
      );
      this.zNodes.forEach((d) => {
        var node = _this.zTeeObj.getNodeByParam("pjdt01", d.pjdt01);
        if (node != null) {
          this.zTeeObj.checkNode(node, true, true);
        }
      });
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.pjdt01;
        _split = ",";
      });
      _this.getData();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.pjdt01;
          _split = ",";
        });
        _this.getData();
      }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangeDrwaingTree({
              oid: moveNode.pjdt01,
              nid: targetNode.pjdt01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: "移动成功",
            });
            return true;
            break;
        }
        return false;
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.ids = treeNode.pjdt01;
        _this.getData();
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "ProjectFileRemenu" ||
            $(event.target).parents("#ProjectFileRemenu").length > 0
          )
        ) {
          $("#ProjectFileRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addProjectFile").show();
          $("#updateProjectFile").hide();
          $("#delProjectFile").hide();
        } else {
          $("#addProjectFile").show();
          $("#updateProjectFile").show();
          $("#delProjectFile").show();
        }
        $("#ProjectFileRemenu").show();
        $("#ProjectFileRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#ProjectFileRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#ProjectFileRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addProjectFile") {
            var newNode = {},
              params = {};
            var node = _this.selectNode;
            params = {
              pjdt02: "新建图纸目录",
              pjdt03: _this.selectNode == null ? 0 : _this.selectNode.pjdt01,
              pjdt04: localStorage.getItem("xid"),
              pjdt07: localStorage.id,
            };
            AddDrwaingTree(params).then((res) => {
              if (res.Code > 0) {
                _this.$message({
                  type: "success",
                  message: "添加成功",
                });
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "pjdt01",
                  newNode.pjdt01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: "添加失败",
                });
              }
            });
          } else if (type == "delProjectFile") {
            _this.$confirm("确认删除当前以及附属节点？").then((_) => {
              var treeNodes = _this.zTeeObj.transformToArray(_this.selectNode);
              var ids = "",
                _split = "";
              treeNodes.forEach((element) => {
                ids += _split + element.pjdt01;
                _split = ",";
              });
              let params = { xid: localStorage.getItem("xid"), zid: ids };
              DelDrwaingTree(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "pjdt01",
                    _this.selectNode.pjdt01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "warning",
                    message: "删除失败",
                  });
                }
              });
            });
          } else if (type == "WorkPlaneLink") {
            _this.associated(_this.selectNode);
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.pjdt02) {
          let params = {
            zid: treeNode.pjdt01,
            name: newName,
          };
          EditDrwaingTree(params).then((res) => {
            _this.$message({
              type: "success",
              message: "更新成功",
            });
          });
        }
      }
    },
    // 获取所有数据
    getData() {
      let params = {
        zid: this.ids,
      };
      this.tableLoading = true;
      FindDrawingInfo({ params }).then((res) => {
        this.tableLoading = false;
        this.inform = res.Data;
      });
    },
    Getpdrwaingtree() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      Getpdrwaingtree({ params }).then((res) => {
        this.zNodes = res.Data || [];
        this.init();
      });
    },
  },
  created() {},
  mounted() {
    this.Getpdrwaingtree();
  },
};
</script>

<style lang="less" scoped>
div#ProjectFileRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#ProjectFileRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#ProjectFileRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#ProjectFileRemenu ul li:hover {
  background: #eee;
  color: #000000;
}
#ProjectFileTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.mar-top20 {
  margin-top: 20px;
}
.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}
.width100-mar-bot20 {
  width: 100%;
  margin-bottom: 20px;
}
</style>
